import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'
// import FULLCALENDAR from '../plugins/fullcalendar'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'contentFooter': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
  }

  VIEWPORTS() // Viewportの置き換え
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html',
      target: 'footer #footerNav',
      method:'replaceWith'
    },
    {
      name: 'contentFooter',
      loadhtml: '/asset/html/contentFooter.html?ts=20191007',
      target: 'footer,#footer.ui-footer',
      method:'before',
      callback(r,_){
        $('.homeContentslist').insertBefore('#footer');
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav li').currentMenu({item:'>a',mode:1,default:999});
        $('header .p-gnav__subnav').currentMenu({mode:0,default:999});
      }
    }
  ])
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'サイトマップ',
    'privacy':'プライバシーポリシー',
    'profile':'会社概要'
  })

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'<svg class="svgicon"><use xlink:href="/asset/svg/sprite.symbol.svg#arrow_left"></use></svg><span>PREV</span>',
      next:'<span>NEXT</span><svg class="svgicon"><use xlink:href="/asset/svg/sprite.symbol.svg#arrow_right"></use></svg>',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })
  })

  

  window.load['contentFooter'].done(() => {
    if(location.pathname.replace('main.php','') == '/') return false
    document.querySelector('.p-contfooter__map').remove()
  })

}